// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RlWx","comment":"styles_comment__1w36j"};